import { render, staticRenderFns } from "./SelectBclass.vue?vue&type=template&id=3ed2ab5a&scoped=true&"
import script from "./SelectBclass.vue?vue&type=script&lang=js&"
export * from "./SelectBclass.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ed2ab5a",
  null
  
)

export default component.exports